import React from 'react';
import { InputNumber } from 'primereact/inputnumber';

const ItemNumberInput = ({ value, onChange }) => {
  return (
    <div className="likkan-stepper">
      <button
        type="button"
        className="p-button p-button-sm p-button-outlined p-button-secondary likkan-stepper-btn"
        onClick={() => onChange(Math.max(0, (value || 0) - 1))}
      >
        −
      </button>
      <InputNumber
        value={value || 0}
        onValueChange={(e) => onChange(e.value ?? 0)}
        showButtons={false}
        inputClassName="likkan-stepper-input"
        min={0}
      />
      <button
        type="button"
        className="p-button p-button-sm p-button-outlined p-button-secondary likkan-stepper-btn"
        onClick={() => onChange((value || 0) + 1)}
      >
        ＋
      </button>
    </div>
  );
};

export default ItemNumberInput;
